import { useEffect, useState } from "react";
import { useUserInfor } from "../../../../../../../Context/User";
import { AtualizarConfigGeralController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import UnForm from "../../../../../../Form";
import { IConfigGeral_URA } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import OrSpinner from "../../../../../../Utils/OrSpinner";
import { IConfigGeralModulos } from "../../../../../../../Interfaces/Geral/ConfigGeral/ConfigGeral";
import useAsyncEffect from "../../../../../../../hooks/useAsyncEffect";
import { GetConfigModuloController } from "../../../../../../../Controllers/Geral/ConfigGeral/ConfigGeralController";

interface IAssistenciaConfigProps {
    lstConfigModulo: IConfigGeralModulos[] | undefined;
    AtualizarConfigModulo: (requestBody: IConfigGeralModulos) => Promise<any>;
    ListConfigModulo: (...args: any[]) => Promise<IConfigGeralModulos[]>;
}

export default function AssistenciaConfig(props: IAssistenciaConfigProps) {
    const { Config, updateConfig } = useUserInfor();
    const config = Config.ConfigAssistenciaTecnicaDTO;
    const { ConfigAssistenciaTecnicaDTO } = useUserInfor().Config;
    let configUra = Config.ConfigsUraDTO;
    const [findCategoria, setFindCategoria] = useState<
        IConfigGeral_URA | undefined
    >();
    const [loading, setLoading] = useState(true);

    const idModuloAssistenciaTecnica = props.lstConfigModulo?.find(
        (lst) => lst.ID_MODULO === 1
    );

    const { value: getConfigModulo } = useAsyncEffect(async () => {
        if (idModuloAssistenciaTecnica) {
            return GetConfigModuloController(
                idModuloAssistenciaTecnica.ID_MODULO
            );
        }
    }, [idModuloAssistenciaTecnica]);

    function update() {
        AtualizarConfigGeralController({
            ...Config,
            ConfigAssistenciaTecnicaDTO: {
                ...config,
            },
            ConfigsUraDTO: configUra,
        }).then(() => {
            updateConfig();
        });
    }

    useEffect(() => {
        if (loading) {
            const findCategoriaAtendimento = configUra?.find((config) => {
                return config.ID_TIPO_CASO === 2;
            });
            setFindCategoria(findCategoriaAtendimento);
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configUra]);

    const handleSubmit = (formValue: any) => {
        configUra = formValue.ID_CATEGORIA_ATENDIMENTO_URA
            ? [
                  {
                      ID_CATEGORIA_ATENDIMENTO:
                          formValue.ID_CATEGORIA_ATENDIMENTO_URA,
                      ID_TIPO_CASO: 1,
                  },
              ]
            : configUra;
        update();
    };
    return (
        <OrSpinner loading={loading} loadingColor="primary">
            <div className="col-12 mb-4">
                <h4>Enviar e-mail de notificação</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir que seja enviado um e-mail ao avançar etapa
                        para o cliente?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config.FL_ENVIAR_EMAIL_CLIENTE_AT}
                                    onChange={() => {
                                        config.FL_ENVIAR_EMAIL_CLIENTE_AT =
                                            !config.FL_ENVIAR_EMAIL_CLIENTE_AT;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Enviar e-mail de notificação por grupo</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir que seja enviado um e-mail ao avançar etapa por
                        grupo?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config.FL_NOTIFICA_GRUPO}
                                    onChange={() => {
                                        config.FL_NOTIFICA_GRUPO =
                                            !config.FL_NOTIFICA_GRUPO;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Venda Cancelada</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Mostrar venda cancelada.
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        Config.ConfigCRMDTO
                                            .FL_MOSTRAR_VENDA_CANCELADA
                                    }
                                    onChange={() => {
                                        Config.ConfigCRMDTO.FL_MOSTRAR_VENDA_CANCELADA =
                                            !Config.ConfigCRMDTO
                                                .FL_MOSTRAR_VENDA_CANCELADA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            {ConfigAssistenciaTecnicaDTO.FL_PERMITIR_MANUTENCAO_CONCLUIDA ===
            true ? (
                <>
                    <div className="col-12 mb-4">
                        <h4>Custos</h4>
                        <div className="d-flex flex-column">
                            <label className="col-12 col-form-label px-0">
                                Permitir Custear o cliente
                            </label>
                            <div className="col-12">
                                <span className="switch switch-outline switch-icon switch-success">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                config.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO
                                            }
                                            onChange={() => {
                                                config.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO =
                                                    !config.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO;
                                                update();
                                            }}
                                            name="select"
                                        />

                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mb-4">
                        <h4>Reparo</h4>
                        <div className="d-flex flex-column">
                            <label className="col-12 col-form-label px-0">
                                Permitir que o reparo seja concluído e custeada?
                            </label>
                            <div className="col-12">
                                <span className="switch switch-outline switch-icon switch-success">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                config.FL_PERMITIR_MANUTENCAO_CONCLUIDA
                                            }
                                            onChange={() => {
                                                config.FL_PERMITIR_MANUTENCAO_CONCLUIDA =
                                                    !config.FL_PERMITIR_MANUTENCAO_CONCLUIDA;
                                                update();
                                            }}
                                            name="select"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="col-12 mb-4">
                    <h4>Reparo</h4>
                    <div className="d-flex flex-column">
                        <label className="col-12 col-form-label px-0">
                            Permitir que o Reparo seja concluído e custeado?
                        </label>
                        <div className="col-12">
                            <span className="switch switch-outline switch-icon switch-success">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={
                                            config.FL_PERMITIR_MANUTENCAO_CONCLUIDA
                                        }
                                        onChange={() => {
                                            config.FL_PERMITIR_MANUTENCAO_CONCLUIDA =
                                                !config.FL_PERMITIR_MANUTENCAO_CONCLUIDA;
                                            update();
                                        }}
                                        name="select"
                                    />
                                    <span></span>
                                </label>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="col-12 mb-4">
                <h4>Finalizar Reparo</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir que o reparo seja finalizado sem informar o
                        motivo?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_FINALIZAR_REPARO_SEM_MODAL
                                    }
                                    onChange={() => {
                                        config.FL_FINALIZAR_REPARO_SEM_MODAL =
                                            !config.FL_FINALIZAR_REPARO_SEM_MODAL;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div className="col-12 mb-4">
                <h4>Abrir novo atendimento</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Abrir novo atendimento ao receber resposta do cliente no
                        email de finalização do caso.
                    </label>
                    <div className="col-6">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        getConfigModulo?.ConfigModuloCampo
                                            .FL_CRIAR_ATEND_RESPOSTA_EMAIL
                                    }
                                    onChange={(e) => {
                                        props
                                            .AtualizarConfigModulo({
                                                ConfigModuloCampo: {
                                                    FL_CRIAR_ATEND_RESPOSTA_EMAIL:
                                                        Boolean(
                                                            e.target.checked
                                                        ),
                                                },
                                                ID_MODULO:
                                                    getConfigModulo?.ID_MODULO ??
                                                    0,
                                            })
                                            .then(() => {
                                                props.ListConfigModulo();
                                                updateConfig();
                                            });
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div className="col-12 mb-4">
                <h4>Finalizar caso sem SLA</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Deseja encerrar o caso sem aplicar a contagem do SLA?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_PARALISAR_CASO_AT_SEM_SLA
                                    }
                                    onChange={() => {
                                        config.FL_PARALISAR_CASO_AT_SEM_SLA =
                                            !config.FL_PARALISAR_CASO_AT_SEM_SLA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <UnForm handleSubmit={handleSubmit}>
                <div className="d-flex flex-column col-12 col-md-6">
                    <label className="pt-2">
                        Categoria atendimento{" "}
                        <span className="font-weight-bolder">URA</span>
                    </label>
                    <UnForm.SelectCategoriaAtendimento
                        ID_MODULO={1}
                        defaultValue={findCategoria?.ID_CATEGORIA_ATENDIMENTO}
                        name="ID_CATEGORIA_ATENDIMENTO_URA"
                    />
                </div>
                <div className="d-flex align-items-center">
                    <div>
                        <label></label>
                        <UnForm.SubmitButton
                            color="success"
                            icon={faPaperPlane}
                            loadingSize="sm"
                        >
                            Atualizar Categoria
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>
        </OrSpinner>
    );
}
